import React from "react";

export const Title = () => {
  return (
    <div className="row">
      <div className="col">
        <div className="text-center py-5">My Contact List</div>
      </div>
    </div>
  );
};
